<template>
  <div style="height: 100% !important">
    <!--<b-button v-b-toggle.sidebar-left>Toggle Sidebar</b-button>
    <b-sidebar id="sidebar-left" title="Sidebar" shadow>-->
    <LegendList
      :left="true"
      :legendUrl="legendUrl1"
      :layerNumber="1"
      class="legend"
      style="position: absolute; left: 15px; top: 95px; z-index: 100"
    ></LegendList>
    <!--v-if="$store.state.parameterStripe.variable1_display_name"-->
    <!--</b-sidebar>-->
    <div id="printButton"></div>
    <!--<b-button class="m-1" @click="stopTheWidget">Stop</b-button>
    <b-button class="m-1" @click="startTheWidget">Start</b-button>
    <b-button class="m-1" @click="changeSwipeLayer">Change Layer</b-button>-->
    <div id="mapNode" class="map">
      <div id="swipeDiv"></div>
    </div>
    <BaseMapSelector class="baseMapSelector" :map="map" />

    <b-button
      variant="primary"
      class="m-1 homeExtent"
      @click="changeExtent('HU')"
      title="Visszatérés alaphelyzetbe"
      v-b-tooltip.hover
      ><b-icon font-scale="2" icon="house-fill"></b-icon
    ></b-button>

    <KozigSearch class="kozigSearch" :map="map" />

    <LegendList
      :left="false"
      :legendUrl="legendUrl2"
      :layerNumber="2"
      class="legend"
      style="position: absolute; right: 10px; top: 95px; z-index: 100"
    ></LegendList>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { config } from "@/config/config.js";
import LegendList from "./LegendList";
import BaseMapSelector from "./BaseMapSelector.vue";
import KozigSearch from "./KozigSearch.vue";
import axios from "axios";
var arcGis = null;
export default {
  name: "Map",
  components: {
    LegendList,
    BaseMapSelector,
    KozigSearch,
  },
  data: function () {
    return {
      map: undefined,
      legendUrl1:
        "https://dev92-pc:6443/arcgis/rest/services/Meteorologia/mosaic_dataset/ImageServer/legend?bandIds=&renderingRule=%7B%22rasterFunction%22%3A%22test%22%7D&f=pjson",
      legendUrl2:
        "https://dev92-pc:6443/arcgis/rest/services/Meteorologia/mosaic_dataset/ImageServer/legend?bandIds=&renderingRule=%7B%22rasterFunction%22%3A%22Classified%22%7D&f=pjson",
      swipeWidget: undefined,
      swipeLayer: undefined,
      kozigLayer2: undefined,
      zoomToFullExtent: function () {},
    };
  },
  computed: {
    compare() {
      return this.$store.state.parameterStripe.compare;
    },
  },
  watch: {
    compare: function () {
      if (this.compare) {
        this.startTheWidget();
      } else {
        this.stopTheWidget();
      }
    },
  },
  created() {
    this.mapInit();
    this.$root.$refs.MapRef = this;
  },
  methods: {
    mapInit() {
      let self = this;
      loadModules([
        "esri/map",
        "esri/layers/ArcGISImageServiceLayer",
        "esri/dijit/LayerSwipe",
        "esri/layers/RasterFunction",
        "esri/dijit/Print",
        "esri/tasks/PrintTemplate",
        "esri/geometry/Extent",
        "esri/request",
        "esri/config",
        "dojo/_base/array",
        "dojo/dom",
        "dojo/parser",
        "esri/layers/ArcGISDynamicMapServiceLayer",
        "esri/tasks/Geoprocessor",
        "esri/layers/ArcGISTiledMapServiceLayer",
        "esri/layers/OpenStreetMapLayer",
      ]).then(
        ([
          Map,
          ArcGISImageServiceLayer,
          LayerSwipe,
          RasterFunction,
          Print,
          PrintTemplate,
          Extent,
          esriRequest,
          esriConfig,
          arrayUtils,
          dom,
          parser,
          ArcGISDynamicMapServiceLayer,
          Geoprocessor,
          ArcGISTiledMapServiceLayer,
          OpenStreetMapLayer,
        ]) => {
          arcGis = this;
          let map = new Map("mapNode", {
            /*center: [19.503, 47.18],
          zoom: 8,*/
            extent: new Extent({
              xmin: 1793786.7314000018,
              ymin: 5738320.860799998,
              xmax: 2548827.0753999986,
              ymax: 6204779.303900003,
              spatialReference: { wkid: 102100 },
            }),
            basemap: "topo",
            maxZoom: 13,
          });

          let layerIds = map.layerIds;
          console.log(layerIds);
          let basemapLayer = map.getLayer(layerIds[0]);
          let basemapLayer2 = undefined;

          self.$store.state.map.changeBasemap = function (mapName) {
            let basemapUrl = undefined;
            let basemapUrl2 = undefined;
            switch (mapName) {
              case "dark-gray":
                basemapUrl =
                  "https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Dark_Gray_Base/MapServer";
                basemapUrl2 =
                  "https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer";
                break;
              case "topo":
                basemapUrl =
                  "https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer";
                break;
              case "satellite":
                basemapUrl =
                  "https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer";
                break;
              case "terrain":
                basemapUrl =
                  "https://services.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer";
                basemapUrl2 =
                  "https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Reference_Overlay/MapServer";
                break;
              case "hybrid":
                basemapUrl =
                  "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer";
                basemapUrl2 =
                  "https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer";
                break;
              default:
                basemapUrl =
                  "https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer";
                break;
            }
            map.removeLayer(basemapLayer);
            if (basemapLayer2) {
              map.removeLayer(basemapLayer2);
              basemapLayer2 = undefined;
            }
            //map.removeLayer(basemapLayer2);
            if (mapName == "osm") {
              basemapLayer = new OpenStreetMapLayer();
              //basemapLayer2 = undefined;
              map.addLayer(basemapLayer, 0);
            } else {
              basemapLayer = new ArcGISTiledMapServiceLayer(basemapUrl, {
                visible: true,
              });
              map.addLayer(basemapLayer, 0);
              if (basemapUrl2) {
                basemapLayer2 = new ArcGISTiledMapServiceLayer(basemapUrl2, {
                  visible: true,
                });
                map.addLayer(basemapLayer2, 1);
              }
            }

            /*if (basemapUrl2){

            }*/
            console.log(map);
          };

          self.map = map;
          let imageLayer2 = new ArcGISImageServiceLayer(
            config.imageService.teszt,
            { opacity: config.defaultOpacity }
          );
          imageLayer2.setDefinitionExpression("name = 'alma'");

          let imageLayer1 = new ArcGISImageServiceLayer(
            config.imageService.teszt,
            { opacity: config.defaultOpacity }
          );
          imageLayer1.setDefinitionExpression("name = 'alma'");

          self.swipeLayer = imageLayer2;
          map.addLayer(imageLayer1);

          var kozigLayer1 = new ArcGISDynamicMapServiceLayer(
            config.kozigMap.url,
            {
              useMapImage: true,
            }
          );
          kozigLayer1.setVisibleLayers([-1]);
          kozigLayer1.setImageFormat("png32");
          kozigLayer1.setDPI(150);
          map.addLayer(kozigLayer1);

          map.addLayer(imageLayer2);

          var kozigLayer2 = new ArcGISDynamicMapServiceLayer(
            config.kozigMap.url,
            {
              useMapImage: true,
            }
          );
          kozigLayer2.setVisibleLayers([-1]);
          kozigLayer2.setImageFormat("png32");
          kozigLayer2.setDPI(150);
          map.addLayer(kozigLayer2);
          self.kozigLayer2 = kozigLayer2;
          this.setKozigLayerVisible = function (kozigLayerType, layerNumber) {
            //TODO 2 közig layer, és a jobb oldali kerüljön bele a swipe-ba
            var kozigLayerToChange;
            if (layerNumber == 1) {
              kozigLayerToChange = kozigLayer1;
            } else {
              kozigLayerToChange = kozigLayer2;
            }
            if (kozigLayerType == "ME") {
              kozigLayerToChange.setVisibleLayers([config.kozigMap.megye]);
            } else if (kozigLayerType == "JA") {
              kozigLayerToChange.setVisibleLayers([config.kozigMap.jaras]);
            } else if (kozigLayerType == "BK") {
              kozigLayerToChange.setVisibleLayers([config.kozigMap.bp]);
            } else {
              kozigLayerToChange.setVisibleLayers([-1]);
            }
          };
          var printGeoProcess = new Geoprocessor(config.printGeoprocess.url);
          this.printWithGeoProc = function (rasterName) {
            var inputParameters = {};
            inputParameters.inputRasterName = rasterName; //"OBS_ta_19712000_01_o_0_HU.tif";
            var currentExtent = map.extent;
            inputParameters.inputExtent = "DEFAULT";
            /*currentExtent.xmin +
              "," +
              currentExtent.ymin +
              "," +
              currentExtent.xmax +
              "," +
              currentExtent.ymax; */
            //"1989713,5960578,1907241,6023636";
            printGeoProcess.submitJob(
              inputParameters,
              printProcCallback,
              statusCallback,
              handlePrintError
            );
            function printProcCallback(response) {
              console.log(response);
              printGeoProcess.getResultData(
                response.jobId,
                "outPDF",
                processPdf
              );
            }
            function statusCallback(jobInfo) {
              console.log(jobInfo.jobStatus);
              if (jobInfo.jobStatus == "esriJobFailed") {
                self.$store.state.parameterStripe.reEnablePrint();
                self.makeToast(
                  "Hiba történt a nyomtatás során.",
                  "hiba",
                  "danger"
                );
              }
            }
            function processPdf(data) {
              console.log("outPDF");
              console.log(data);
              self.$store.state.parameterStripe.reEnablePrint();
              var fileName = rasterName.replace("tif", "pdf");
              const link = document.createElement("a");
              link.href = data.value.url;
              link.target = "_blank";
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
            }
            function handlePrintError(error) {
              console.log(error);
              self.$store.state.parameterStripe.reEnablePrint();
              self.makeToast(
                "Hiba történt a nyomtatás során.",
                "hiba",
                "danger"
              );
            }
          };

          this.setLayerOpacity = function (opacity, layerNumber) {
            if (layerNumber == 1) {
              imageLayer1.setOpacity(opacity);
            } else {
              imageLayer2.setOpacity(opacity);
            }
          };
          this.changleLayer = function (
            url,
            definitionQuery,
            rasterFunctionName,
            layerNumber
          ) {
            let layerToChange;
            if (layerNumber == 1) {
              layerToChange = imageLayer1;
              //map.removeLayer(imageLayer1);
            } else {
              layerToChange = imageLayer2;
              //map.removeLayer(imageLayer2);
            }
            //layerToChange = new ArcGISImageServiceLayer(url);
            layerToChange.setDefinitionExpression(definitionQuery);
            let rasterFunction = new RasterFunction();
            rasterFunction.functionName = rasterFunctionName; // JSON.parse(rasterFunctionJson).rasterFunction;
            //map.addLayer(layerToChange);
            console.log(map);
            layerToChange.setRenderingRule(rasterFunction);
            console.log(layerToChange.renderingRule);
            //Ide raster function létrehozása kell majd
          };
          this.changeExtent = function (extentName) {
            console.log("Extent váltás function: " + extentName);
            var extent;
            if (extentName == "Budapest") {
              extent = new Extent({
                xmin: 2106843.0111999996,
                ymin: 5999298.8094,
                xmax: 2152306.3757000007,
                ymax: 6042717.303099997,
                spatialReference: { wkid: 102100 },
              });
            } else if (extentName == "Szeged") {
              extent = new Extent({
                xmin: 2236420.78,
                ymin: 5806017.05,
                xmax: 2250260.68,
                ymax: 5837406.16,
                spatialReference: { wkid: 102100 },
              }).expand(1.3);
            } else {
              extent = new Extent({
                xmin: 1793786.7314000018,
                ymin: 5738320.860799998,
                xmax: 2548827.0753999986,
                ymax: 6204779.303900003,
                spatialReference: { wkid: 102100 },
              });
            }
            map.setExtent(extent);
          };
          this.zoomToFeature = function (feature) {
            map.setExtent(feature.geometry.getExtent());
          };
          let mapElementSize = document
            .getElementById("mapNode")
            .getBoundingClientRect();
          let swipePosition = mapElementSize.width / 2;
          self.$store.state.map.swipePosFromLeft = swipePosition;
          let swipeWidget = new LayerSwipe(
            {
              type: "vertical", //Try switching to "scope" or "horizontal"
              map: map,
              layers: [imageLayer2, kozigLayer2],
              left: swipePosition,
              invertPlacement: true,
            },
            "swipeDiv"
          );
          self.swipeWidget = swipeWidget;
          swipeWidget.startup();
          swipeWidget.on("swipe", swipeDataLog);
          function swipeDataLog(event) {
            console.log(event);
            console.log("Swipe_left:" + event.layers[0].left);
            //map.infoWindow.hide();
            self.$store.state.map.swipePosFromLeft = event.layers[0].left;
          }
          this.stopTheWidget();
          map.on("click", doIdentify);
          function doIdentify(event) {
            map.graphics.clear();
            var mapPoint = event.mapPoint;
            var screenPoint = event.screenPoint;
            //TODO itt kellene figyelni, hogy a swipe-tól balra vagyunk-e. Ez nagyjából a def query szempontjából fontos
            //városmodellnél másik image service url kell majd
            let rasterName;
            console.log("screenpoint_x:" + screenPoint.x);
            //TODO itt kellene elágazni
            if (self.$store.state.parameterStripe.compare) {
              var url1 =
                config.imageService.teszt +
                "/identify?geometry=%7Bx%3A" +
                mapPoint.x +
                "%2Cy%3A" +
                mapPoint.y +
                "%2C+spatialReference%3A%7Bwkid%3A" +
                mapPoint.spatialReference.wkid +
                "%7D%7D&geometryType=esriGeometryPoint&mosaicRule=%7B%22mosaicMethod%22%3A%22esriMosaicNone%22%2C%22where%22%3A%22name+%3D+%27" +
                self.$store.state.parameterStripe.raster_name_1 +
                "%27%22%2C%22ascending%22%3Afalse%7D&renderingRule=&renderingRules=&pixelSize=&time=&returnGeometry=false&returnCatalogItems=false&returnPixelValues=true&maxItemCount=&f=pjson";
              var url2 =
                config.imageService.teszt +
                "/identify?geometry=%7Bx%3A" +
                mapPoint.x +
                "%2Cy%3A" +
                mapPoint.y +
                "%2C+spatialReference%3A%7Bwkid%3A" +
                mapPoint.spatialReference.wkid +
                "%7D%7D&geometryType=esriGeometryPoint&mosaicRule=%7B%22mosaicMethod%22%3A%22esriMosaicNone%22%2C%22where%22%3A%22name+%3D+%27" +
                self.$store.state.parameterStripe.raster_name_2 +
                "%27%22%2C%22ascending%22%3Afalse%7D&renderingRule=&renderingRules=&pixelSize=&time=&returnGeometry=false&returnCatalogItems=false&returnPixelValues=true&maxItemCount=&f=pjson";
              let promise1 = axios.get(url1);
              let promise2 = axios.get(url2);
              Promise.all([promise1, promise2]).then((values) => {
                console.log(values[0]);
                map.infoWindow.setTitle("A kattintott pixel értéke");
                map.infoWindow.setContent(
                  "Bal oldali réteg értéke: " +
                    Math.round(values[0].data.value * 10) / 10 +
                    "<br/>Jobb oldali réteg értéke: " +
                    Math.round(values[1].data.value * 10) / 10
                );
                map.infoWindow.show(
                  screenPoint,
                  map.getInfoWindowAnchor(screenPoint)
                );
              });
            } else {
              if (
                self.$store.state.parameterStripe.compare &&
                screenPoint.x > self.$store.state.map.swipePosFromLeft
              ) {
                rasterName = self.$store.state.parameterStripe.raster_name_2;
              } else {
                rasterName = self.$store.state.parameterStripe.raster_name_1;
              }
              var url =
                config.imageService.teszt +
                "/identify?geometry=%7Bx%3A" +
                mapPoint.x +
                "%2Cy%3A" +
                mapPoint.y +
                "%2C+spatialReference%3A%7Bwkid%3A" +
                mapPoint.spatialReference.wkid +
                "%7D%7D&geometryType=esriGeometryPoint&mosaicRule=%7B%22mosaicMethod%22%3A%22esriMosaicNone%22%2C%22where%22%3A%22name+%3D+%27" +
                rasterName +
                "%27%22%2C%22ascending%22%3Afalse%7D&renderingRule=&renderingRules=&pixelSize=&time=&returnGeometry=false&returnCatalogItems=false&returnPixelValues=true&maxItemCount=&f=pjson";

              axios.get(url).then((response) => {
                console.log(response);
                map.infoWindow.setTitle("A kattintott pixel értéke");
                map.infoWindow.setContent(
                  "Érték: " + Math.round(response.data.value * 10) / 10
                );
                map.infoWindow.show(
                  screenPoint,
                  map.getInfoWindowAnchor(screenPoint)
                );
              });
            }

            //console.log("{x: "+ mapPoint.x + ", y: " + mapPoint.y + ", spatialReference: {wkid: " + mapPoint.spatialReference.wkid + /*", latestWkid: " + mapPoint.spatialReference.latestWkid +*/ "}}")
          }
        }
      );
    },
    stopTheWidget() {
      this.swipeLayer.setVisibility(false);
      this.kozigLayer2.setVisibility(false);
      this.swipeWidget.disable();
    },
    startTheWidget() {
      this.swipeLayer.setVisibility(true);
      this.kozigLayer2.setVisibility(true);
      this.swipeWidget.enable();
    },
    changeSwipeLayer() {
      this.swipeLayer.setDefinitionExpression("name = 'tm024000_20180401'");
    },
    setLayerOpacity(opacity, layerNumber) {
      arcGis.setLayerOpacity(opacity, layerNumber);
    },
    makeToast(message, titleToShow, variant = null) {
      this.$bvToast.toast(message, {
        title: titleToShow,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
        autoHideDelay: 8000,
      });
    },
    /*changleLayer(url, definitionQuery, layerNumber) {
      arcgis.changleLayer(url, definitionQuery, layerNumber);
    },*/
    /*changeExtent(extentName) {
      console.log("Extent váltás method: " + extentName);
      arcgis.changeExtent(extentName);
    },*/
  },
};
</script>

<style scoped>
#mapNode {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 800px;
  position: relative;
}
.flex-container {
  display: flex;
  height: 100% !important;
}
.map {
  width: 100% !important;
  height: 100% !important;
  /*height: calc(100% - 400px) !important;position: absolute!important;
  height: calc(100vh - 220px)!important;
  left:200px;*/
}
.legend {
}
.baseMapSelector {
  position: absolute;
  right: 130px;
  top: 7px;
  z-index: 101;
  font-size: 1.25em;
}
#printButton {
  position: absolute;
  right: 20px;
  top: 40px !important;
}
.kozigSearch {
  position: absolute;
  left: 130px;
  top: 20px;
  z-index: 101;
}

.homeExtent {
  position: absolute;
  left: 70px;
  top: 19px;
  height: 40px !important;
  width: 40px !important;
  /*width: 32px !important;*/
}
>>> .tooltip-inner {
  background-color: white;
  color: black;
  border: 1px solid;
  border-color: black;
  font-size: 1.25em;
}
</style>
